import React from "react";
import { useSelector } from "react-redux";
import { isMobile } from "utils/device-detect";
import ReactivateSubscription from "components/reactivate-subscription";
import { useGlobalContext } from "context/global";

const ReactivationBanner = () => {
	const { translation } = useGlobalContext();
	const { subscriptionId, isActive, status } = useSelector(state => state.account.subscription);

	const formattedStatus = translation.subscription?.status[status.toLowerCase()]?.toLowerCase();
	const statusMessage = isMobile() ? translation.subscription.reactivation_banner_message_mobile : translation.subscription.reactivation_banner_message;
	const message = statusMessage?.replace("{status}", formattedStatus);
    
	if(!subscriptionId || isActive) return null;

	return (
		<div className="bg-light-gray fixed w-full bottom-0 z-[20] md:gap-0 gap-2 py-3 flex justify-around items-center flex-col md:flex-row">
			<span className="md:max-w-[50%] text-center md:text-left">{message}</span>
			<ReactivateSubscription className="!btn-orange py-3 !w-56" />
		</div>
	);
};

export default ReactivationBanner;